// plugins/v-track-click.ts
import { useStoreGtm } from '~/stores/abstract/gtm';
import type { DirectiveBinding, ObjectDirective } from 'vue';
import type { IGtmPush } from '~/types/gtm';

const handlerMap = new WeakMap<HTMLElement, () => void>();

const vGtm: ObjectDirective<HTMLElement, IGtmPush> = {
  mounted(el, binding: DirectiveBinding<IGtmPush>) {
    const gtm = useStoreGtm();
    const handler = () => {
      gtm.push(binding.value);
    };
    el.addEventListener('click', handler);
    handlerMap.set(el, handler);
  },

  unmounted(el) {
    const handler = handlerMap.get(el);
    if (handler) {
      el.removeEventListener('click', handler);
      handlerMap.delete(el);
    }
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('gtm', vGtm);
});
